import config from "../config";

const baseUrl = config.base_url + "sys_python_script/";

export default {
    list: {
        url: baseUrl + "list",
        type: "post",
    },
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    batchDelete: {
        url: baseUrl + "batchDelete",
        type: "post",
    },
    test: {
        url: baseUrl + "test",
        type: "get",
    },
};
